import { DocumentOnView } from 'presentation/document/documentOnView';
import { DocumentModel } from 'shared/domain/document/documentModel';
import { DOCUMENT_PENDING_SOURCE } from 'shared/domain/document/documentError';

export function documentModelToDocumentOnView(
  document: DocumentModel
): DocumentOnView | undefined {
  if (!document.data) {
    return undefined;
  }

  return {
    _id: document._id,
    localId: document.localId,
    title: document.title,
    // if we say 'FILE', it will show (jpg icon)
    type: document.type,
    isExportAllowed: document.isExportAllowed,
    data: document.data,
    // TODO: PT-3773
    description: document.description,
    deleted: document.deleted,
    localData: document.localData,
    src: DOCUMENT_PENDING_SOURCE,
    downloadSrc: document.localData || '',
    syncStatus: document.syncStatus,
    drawingSyncStatus: document.drawingSyncStatus,
    modifiedAt: document.modifiedAt,
    imageRotation: document.imageRotation,
    imageConvertStatus: document.imageConvertStatus,
  };
}
